/**
 * Potrivire TOLERANTA a unei valori de judet, primite din API/import, cu lista canonica de 42 de
 * nume (`GET /api/schools/counties`, toate MAJUSCULE, fara diacritice).
 *
 * De ce exista: `judet` ajunge nenormalizat in `School.adresa.judet` pe doua cai — importul MEC
 * (`ImportMecService.aplica`, copie bruta din fisier) si aprobarea unei cereri
 * (`SchoolRequestService.java:977`, copie bruta din formularul de cerere, care la randul lui
 * preia valoarea DIRECT din datele de import prin `SchoolRequestFormPage.tsx:327-329`). Rezultatul,
 * masurat pe `ecotic-test`: scoli reale cu `judet` scris `Bucuresti`/`Cluj` in loc de
 * `BUCURESTI`/`CLUJ`. `<Select>` (Radix) cere potrivire EXACTA intre `value` si un `SelectItem`,
 * deci un `judet` nenul dar cu alta majusculare arata identic cu unul lipsa — «Selectați județul»,
 * desi campul chiar are o valoare.
 *
 * Fix-ul REAL (normalizare la scriere + backfill pe randurile deja gresite) e in backend, pe F1.
 * Functia de aici e completarea de partea clientului: datele deja scrise gresit (si orice sursa
 * viitoare nenormalizata) nu trebuie sa lase un profesor blocat cu un camp aparent gol.
 *
 * Acopera DOAR majuscule/diacritice, NU coduri de abreviere („B", „MM" — vazute in
 * `school_data_imports`, tabela bruta de import, nu inca pe o scoala aprobata): frontendul n-are
 * de unde sa stie ca „MM" inseamna Maramures fara harta de coduri a backendului
 * (`CountyAbbreviations`), care nu e expusa prin API. O potrivire pe cod ar fi ghicit, nu
 * rezolvare.
 */

/** `Bistrița-Năsăud` -> `BISTRITA-NASAUD`: majuscule, fara diacritice, spatii colapsate. */
function normalizeaza(text: string): string {
    return text
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toUpperCase()
        .trim()
        .replace(/\s+/g, ' ');
}

/**
 * Intoarce numele CANONIC din `optiuni` care se potriveste tolerant cu `valoare`, sau `undefined`
 * daca niciunul nu se potriveste — caz in care apelantul lasa campul necompletat (control negativ:
 * un judet lipsa sau un cod/nume necunoscut ramane pe placeholder, cere selectare manuala, exact ca
 * azi).
 */
export function rezolvaJudet(
    valoare: string | null | undefined,
    optiuni: readonly string[] | undefined,
): string | undefined {
    if (!valoare || !optiuni?.length) return undefined;
    if (optiuni.includes(valoare)) return valoare;

    const cautat = normalizeaza(valoare);
    return optiuni.find((optiune) => normalizeaza(optiune) === cautat);
}
